import { computed } from 'vue';
import { useCurrency } from '../../../common/js/composables/currency';

export const MOBILE_PREFIX = ['20', '30', '31', '50', '70'];
export const ORDER_TYPE_OPTIONS = [
	{ key: 'ACTUAL_ORDER', value: 'Készpénzátutalási megbízást' },
	{ key: 'TEMPLATE_ORDER', value: 'Minta készpénzátutalási megbízást postai bevizsgáltatáshoz (OC31 és OC32 esetén)' }
];
export const TRANSACTION_CODE_OPTIONS = [
	{
		key: 54,
		value: 'A  befizetők az összeget és a megbízóazonosítót (befizetőazonosítót) a kézi kitöltésre kijelölt rovaton tüntetik fel.'
	},
	{
		key: 55,
		value: 'A befizetők az összeget, nevet és címet a kézi kitöltésre kijelölt rovaton tüntetik fel, nem rendelkeznek megbízóazonosítóval (befizetőazonosítóval).'
	}
];
export const OUTPUT_CODE_OPTIONS = [
	{
		key: 21,
		value: 'a bizonylat eredeti nagyságban nyomtatott másolata (kizárólag 55-ös tranzakciókód esetén választható)'
	},
	{
		key: 31,
		value: 'elektronikus adatállomány átadás: numerikus adatok (kizárólag 54-es tranzakciókód esetén választható)'
	},
	{ key: 32, value: 'elektronikus adatállomány átadás: képi- és numerikus adatok' }
];
export const DISCHARGE_SIGNAL_OPTIONS = [
	{
		key: 'M',
		value: '- A Magyar Posta Zrt. felé nyilatkozom, hogy a készpénzátutalási megbízások az Európai Parlament és Tanács 1113/2023/EU rendelet 2. cikk (4) b) pontja értelmében mentesülnek az EK rendelet hatálya alól.'
	},
	{
		key: 'FM',
		value: '- A Magyar Posta Zrt. felé nyilatkozom, hogy a készpénzátutalási megbízások az Európai Parlament és Tanács 1113/2023/EU rendelet 2. cikk (5) bekezdés értelmében mentesülnek az EK rendelet hatálya alól.'
	},
	{ key: 'NULL', value: 'Jelzés nélküli, nem mentes' }
];
export const INSPECTED_OPTIONS = [
	{ key: true, value: 'Igen' },
	{ key: false, value: 'Nem' }
];
export const PICK_UP_LOCATION_OPTIONS = [
	{ key: 'POST_OFFICE', value: 'Postán' },
	{ key: 'BRANCH', value: 'Bankfiókban veszem át' }
];

export const useConstants = (prices) => {
	const { formatAmount } = useCurrency();
	const FORMAT_OPTIONS = computed(() => [
		{
			key: 'CUT_INTO_SLICES',
			value: `Egyenkénti, szelvényre vágott – ${formatAmount(prices.sliceNetPrice, { maximumFractionDigits: 2 })}/megbízás + ÁFA`
		},
		{
			key: 'CUT_INTO_SHEET',
			value: `Lapra vágott (3 db megbízás egy lapon) – ${formatAmount(prices.sheetNetPrice, {
				maximumFractionDigits: 2
			})}/megbízás + ÁFA`
		},
		{
			key: 'INVOICE',
			value: `Számlalevél (alulcsekkes), lapra vágott – ${formatAmount(prices.invoiceNetPrice, {
				maximumFractionDigits: 2
			})}/levél + ÁFA`
		}
	]);
	return { FORMAT_OPTIONS };
};
